import { FormForUser, UpdateUserAction, updateUserFormCreator } from "forms/user";
import { inject, ComponentEventBus, prop, NetworkException } from "fw";
import { dispatch } from "fw-state";
import { UserStore } from "state/users";
import { Notification } from "service/notification";
import { CurrentUserStore } from "state/current-user";
import { User } from "models/user";

@inject
export class EditEmailAddressModal {
    @prop(null) userId: string;

    private form: FormForUser = null;
    private updating: boolean = false;

    constructor(
        private ceb: ComponentEventBus,
        private currentUser: CurrentUserStore,
        private userStore: UserStore,
        private notifier: Notification
    ) {}

    public attached() {
        const user = this.getUser(this.userId);
        this.form = updateUserFormCreator(user);
    }

    public async update() {
        try {
            this.updating = true;

            const user = this.getUser(this.form.Id);
            const isEmailUpdated = user.EmailAddress.trim().toLowerCase() !== this.form.EmailAddress.trim().toLowerCase();
            if (!isEmailUpdated) {
                this.ceb.dispatch("close");
                return;
            }

            const action = new UpdateUserAction(this.form);
            await dispatch(action);
            this.form = updateUserFormCreator(action.updated);

            let message = `Email address updated to ${this.form.EmailAddress}. Check your email for a verification request`;
            const { PendingEmailAddress } = this.form.MetaData?.ChangeEmailAddressRequest || {};
            if (PendingEmailAddress) {
                message = "Email address update pending verification. Check your email for a verification request";
            }

            this.notifier.notify(message);

            this.ceb.dispatch("updated", action.updated);
            this.ceb.dispatch("close");
        } catch (err) {
            let msg = "Could not update email address";

            if (err instanceof NetworkException) {
                switch (err.result.Code) {
                    case "BADREQUEST":
                    case "CONFLICT":
                    case "FORBIDDEN":
                        msg += ": " + err.result.Message;
                        break;
                    default:
                        if (err.result.errors) {
                            msg += ": " + err.result.errors.join(", ");
                        }
                        break;
                }
            }
            this.notifier.error(msg);
        } finally {
            this.updating = false;
        }
    }

    public close() {
        this.ceb.dispatch("close");
    }

    private getUser(userId: string): User {
        let user = this.userStore.state.collection.find((i) => i.Id == userId);
        if (!user && this.currentUser.state.user.Id === this.userId) {
            user = this.currentUser.state.user;
        }

        return user;
    }
}
